import {START_PROFIT_WELL} from "./types"

export const startProfitWell = _ => ({
  type: START_PROFIT_WELL,    
});